<template>
  <!--  新增能耗模型：工作日设定-->
<div>
  <div>{{ Data.data.c_name }}</div>
  <div class=" row mb-2">
    <label class="col-sm-4 lh35 text-lr">工作日：</label>
    <div class="col-sm-7 ">
      <el-checkbox-group v-model="checkList">
        <el-checkbox :label="value" v-for="(value,index) in Data.data.c_choice.map" :key="index"
                     @change="clickData"
        ></el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
  <div class=" row mb-2">
    <label class="col-sm-4 lh35 text-lr">占比：</label>
    <div class="col-sm-7 ">
      <el-slider v-model="ratio"  @change="clickData"
                 show-input :max="1" :min="0" :step="0.001">
      </el-slider>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "workDay_block",
  props: ['Data'],
  data() {
    return {
      checkList:this.Data.data.c_value.range,
      ratio:this.Data.data.c_value.ratio,
    }
  },
  methods:{
    //选中值
    clickData() {
      var obj={}
      obj['range']=this.checkList
      obj['ratio']=this.ratio
      this.$get_function(this.Data, obj)
    },
  },
}
</script>

<style scoped>

</style>